'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'car-bump';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f5e0';
var svgPathData = 'M236.6 87.6L100.3 166.4c-5.8 3.3-8.9 9.9-7.8 16.5l12.2 73.3 207.5-119.8-57.4-47.2c-5.2-4.2-12.4-4.8-18.2-1.5zm138.7 17.8l2.8 2.3c22.4-.3 44.3 11.2 56.3 32 8 13.9 24 41.6 48 83.1l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7l-13.9 8c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7-249.4 144 16 27.7c8.8 15.3 3.6 34.9-11.7 43.7l-13.9 8c-15.3 8.8-34.9 3.6-43.7-11.7-8-13.9-24-41.6-48-83.1l-16-27.7c-12-20.8-11-45.5 .4-64.8l-.6-3.5-17-102c-5.5-32.9 10-65.7 38.9-82.4L204.6 32.2c28.9-16.7 65.1-13.7 90.8 7.5l79.9 65.7zm0 123.9a32 32 0 1 0 -32-55.4 32 32 0 1 0 32 55.4zM109.9 345.6a32 32 0 1 0 55.4-32 32 32 0 1 0 -55.4 32zm462 134.9c5 17-9.8 31.6-27.5 31.6l-160 0c-17.7 0-32.5-14.6-27.5-31.6 13.6-46.5 56.6-80.4 107.5-80.4s93.9 33.9 107.5 80.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarBump = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;